<template>
    <div>
        <v-row no-gutters>
            <v-col cols="3">
                <v-card outlined>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-autocomplete v-model="selected_foyer" :items="foyers" item-value="id" item-text="nom_reflex"
                                no-data-text="'AUCUN RÉSULTAT" outlined solo dense label="Foyer" required :rules="[v => !!v || 'Foyer requis!']">
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                {{ data.item.nom_reflex }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-select dense required outlined v-model="selected_annee" :items="annees"
                                item-value="value" item-text="label" :rules="[v => !!v || 'Année requis!']"
                                label="Année"></v-select>
                            <v-btn color="primary" class="mr-4" v-on:click="openRecuImpot">Générer</v-btn>
                        </v-form>

                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="9">
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "../plugins/axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            foyers: [],
            annees: [],
            selected_annee: null,
            selected_foyer: null,
            valid: false,
        };
    },
    mounted() {
        let currentDate = new Date();
        const years = Array.from({ length: 10 }, (_, index) => currentDate.getFullYear() - index)
        this.annees = years.map((el) => {
            return {
                value: el,
                label: el == currentDate.getFullYear() ? `${el} (INCOMPLET)` : el
            }
        })
        this.selected_annee = this.annees.length>1 ? this.annees[1] : this.annees[0]
        axios.get(process.env.VUE_APP_API_URL + "/foyer?show_all=true").then((response) => {
            this.foyers = response.data;
        });
    },
    computed: {
        ...mapGetters(["decoded"]),
    },
    methods: {
        openRecuImpot() {
            if (this.$refs.form.validate()) {
                var debut = `${this.selected_annee.value || this.selected_annee}-01-01`;
                var fin = `${this.selected_annee.value || this.selected_annee}-12-31`;
                const aujourdhui = this.$date.utc();
                if(this.selected_annee.value==aujourdhui.get("year") || this.selected_annee == aujourdhui.get("year")){
                    fin = aujourdhui.format("YYYY-MM-DD");
                }
                window.open(
                    process.env.VUE_APP_API_URL +
                    `/recus_impot/patient?pharmacie_id=${this.decoded.succursale.id}&debut=${debut}&fin=${fin}&foyer_id=` +
                    this.selected_foyer
                );
                return true
            }
        }
    }
}
</script>